module.exports = __webpack_public_path__ + "static/media/course-badge-2.cb40cf59.svg";